import { AddCircleOutline, TaskAlt } from "@mui/icons-material";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { Button, Checkbox } from "@mui/material";
import { useEffect, useState } from "react";

import {
  compareArrayData,
  formatDate,
} from "../../../../../../components/ui library/helpers/functions";
import HNSColors from "../../../../../ui library/HNSColors";
import AddProvider from "../../../../providers/add-alternative-provider/components/AddProvider";
import QuestionTitle from "../QuestionTitle";

const Providers = ({
  data: initialData,
  label,
  providersList,
  handleAnswerChange,
  questionKey,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [providerRows, setProviderRows] = useState(initialData);

  useEffect(() => {
    setProviderRows(initialData);
  }, [initialData]);

  useEffect(() => {
    const changes = compareArrayData(providerRows, initialData);
    if (changes && changes?.length > 0) {
      handleAnswerChange(questionKey, changes);
    } else {
      handleAnswerChange(questionKey, undefined);
    }
  }, [providerRows]);

  const handleSelectedProvider = (id) => {
    const initConfirmedVal = initialData.find((provider) => provider.id === id).confirmed;
    if (initConfirmedVal === false) {
      setProviderRows((prevData) =>
        prevData.map((provider) =>
          provider.id === id ? { ...provider, confirmed: !provider.confirmed } : provider
        )
      );
    }
  };

  return (
    <>
      <div className="flex w-full flex-wrap gap-4">
        {/* Question */}
        <QuestionTitle label={label}>
          <div className="">
            <Button
              sx={{
                color: HNSColors.secondary[500],
                border: `1px solid ${HNSColors.secondary[500]}`,
                "&:hover": {
                  background: HNSColors.secondary[900],
                  border: `1px solid ${HNSColors.secondary[500]}`,
                },
              }}
              className="w-52 rounded-3xl bg-white py-2 pl-8 pr-2 text-xs normal-case"
              variant="outlined"
              onClick={() => setOpenModal(true)}
            >
              Add Provider <AddCircleOutline fontSize="small" className="ml-auto" />
            </Button>
          </div>
        </QuestionTitle>

        {/* Providers */}
        <div className="flex w-full flex-wrap gap-3">
          {providerRows.map((provider) => {
            const details = providersList[provider?.provider];

            return (
              <div
                style={{
                  background: HNSColors.tertiary[900],
                  cursor: "pointer",
                }}
                className="flex w-full items-center gap-2 rounded-lg p-6"
                key={provider?.id}
                onClick={() => handleSelectedProvider(provider.id)}
              >
                <TaskAlt style={{ color: HNSColors.primary[500] }} />
                <p className="line-clamp-1 text-sm">
                  <b>{details?.name}</b> -{" "}
                  <span style={{ color: HNSColors.neutrals[300] }} className="text-xs">
                    ({details?.types.join(", ")})
                  </span>
                </p>
                <div className="ml-auto flex items-center">
                  {provider?.confirmed && provider?.confirmed_at && (
                    <span
                      style={{
                        color: HNSColors.neutrals[300],
                        marginRight: "8px",
                      }}
                      className="text-xs"
                    >
                      (Confirmed Provider - {formatDate(provider?.confirmed_at)})
                    </span>
                  )}

                  <Checkbox
                    icon={
                      <CheckBoxOutlineBlankIcon
                        sx={{ fontSize: 28, fill: HNSColors.neutrals[500] }}
                      />
                    }
                    checkedIcon={<CheckBoxIcon sx={{ fontSize: 28 }} />}
                    checked={provider?.confirmed}
                    sx={{
                      color: HNSColors.neutrals[500],
                      "&.Mui-checked": {
                        color: HNSColors.primary[500],
                      },
                    }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <AddProvider openModal={openModal} setOpenModal={setOpenModal} />
    </>
  );
};

export default Providers;
